import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { countResponseSchema } from '../types';

export const createResetLimitMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'DELETE',
			url: (id) => `/account/wallet/limits/${id}`,
			body: {},
		},
		response: {
			contract: zodContract(countResponseSchema),
		},
	});
